import React, { useContext, useEffect, useState } from "react";
import { getMoengage } from "../../utils/moengage.js";
// import { useHistory } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
import Loading from "../../components/advance/Loading";
import Modal from "../../components/advance/Modal";
// import Button from "../../components/core/Button";
import Button from "../../components/core/EPL_Button_Think";
import CheckField from "../../components/form/CheckField";
import useMediaQuery from "../../hooks/useMediaQuery";
import ErrorModal from "../../modals/ErrorModal";
import { UserContext } from "../../shared/context/UserContext";
// import VendorService from '../../shared/services/VendorService';
// import sendRequest from '../../shared/utils/sendRequest';
import sendRequest from "../../utils/sendRequest";
// import Progress from '../progress/Progress';
// import Summary from '../summary/Summary';
import { AfterLoginLayoutWrapper } from "../_styles/EPL_AfterLoginLayoutWrapper_think";
// import { BasicDetailsForm } from "./_styles/EPL_BasicDetailsForm_think";
import SelfieCapturePng from "../../assets/images/EPL_think_images/Selfie_Mobile.png";
import selfieTitleIcon from "../../assets/svg/EPL_think_svg/Selfie_Title_Icon.svg";
import Title from "../../components/core/Title";
import ProgressBar from "../../components/navigation/progress_bar/EPL_ProgressBar";
import ShimmerPlaceholder from "../../components/placeholders/ShimmerPlaceholder";
import SelfieCaptureModal from "../../modals/SelfieCaptureModal";
import { encrypt } from "../../utils/crypto";
// import { SelfieForm } from "./_styles/SelfieForm";
import JSZip from "jszip";
import { GetCustomerDetailsContext, validateInputExistenece } from "../../App";
import { INSERT_SELFIE, LIVELINESS } from "../../Config";
import SubTitle from "../../components/core/SubTitle";
import { getRouteFromLoanStageService } from "../../shared/services/getRouteFromLoanStageService";
import {
  LocationCaptureModal,
  SelfiePermissionCaptureModal,
  UploadSelfieFailedModal,
} from "../other-pages/Modals/AllModal";
import { SelfieForm } from "./_styles/SelfieForm";
import { updateLead } from "../../shared/services/crm";
import isInIndia from "../../utils/isInIndia";
import { isStageLogin } from "../../shared/validations/StageLogin";
import { userConsentStatus } from "../../utils/userConsentStatus";
import { encryptedData } from "../../utils";

function EPL_Selfie_think() {
  const moengage = getMoengage();
  // const history = useHistory();
  const navigate = useNavigate();
  const isMobile = useMediaQuery("screen and (max-width: 768px)");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  // const [load, setLoad] = useState(false);
  const [modal, setModal] = useState("");
  const [base64, setBase64] = useState(null);
  const [checked, setChecked] = useState(false);
  const [image, setImage] = useState(null);
  const [showCaptureModal, setShowCaptureModal] = useState(false);
  const { user, setUser } = useContext(UserContext);
  const [file, setFile] = React.useState("");
  const [base64String, setBase64String] = useState("");
  const [finalBase64Image, setFinalBase64Image] = useState();
  const [zipContent, setZipContent] = useState();
  const [finalZip, setFinalZip] = useState();
  const [zId, setZId] = useState();
  // const search_params = qs.parse(location.search);
  const [counter, setCounter] = useState(0);
  const [openPopup, setOpenPopup] = useState(false);
  const [message, setMessage] = useState("");
  //   const [customerDetails, setCustomerDetails] = useState(
  //     location?.state?.customerDetails
  //   );
  const [customerDetails, setCustomerDetails] = useContext(
    GetCustomerDetailsContext
  );
  const [maxRetrySelfie, setMaxRetrySelfie] = useState(false);
  const [uploadSelfieFailed, setUploadSelfieFailed] = useState(false);
  const [showShimmer, setShowShimmer] = useState(true);
  const [retryModalMessage, setRetryModalMessage] = useState("");
  const [locationPermission, setLocationPermission] = useState(false);
  const [showLocationModal, setShowLocationModal] = useState(false);
  const [locationMessage, setLocationMessage] = useState("");
  const [showSelfiePermissionModal, setShowSelfiePermissionModal] = useState(false);
  const [selfiePermissionMessage, setSelfiePermissionMessage] = useState("");
  const [userLocation, setUserLocation] = useState({});
  const [locationErrorCount, setLocationErrorCount] = useState(() => parseInt(sessionStorage.getItem("locationErrorCount")));
  const [locationAccessConsent, setlocationAccessConsent] = useState(false)
  const [selfieKycDataconsent, setSelfieKycDataconsent] = useState(false)
  useEffect(() => {
    sessionStorage.setItem("locationErrorCount", locationErrorCount);
  }, [locationErrorCount]);

  useEffect(()=>{
  
      isStageLogin(    
        customerDetails?.Data?.uuid,
        customerDetails?.Data?.mobile,
        customerDetails?.source,
      );
  }, [])
    

  useEffect(() => {
    // if(validateInputExistenece(customerDetails) && validateInputExistenece(customerDetails["stage"])) {
    if (validateInputExistenece(customerDetails)) {
      // console.log("Selfie customerDetails: ", customerDetails);
      setShowShimmer(false);
      // TODO: Handle Staging if needed

      // navigate("/details", {
      //   replace: true,
      //   state: {
      //     customerDetails: customerDetails,
      //   },
      // });
    }
    if (
      validateInputExistenece(customerDetails) &&
      validateInputExistenece(customerDetails["stage"])
    ) {
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: customerDetails.stage,
      });
      // console.log("stage: ", customerDetails.stage);
      // console.log("route: ", route);
      navigate(`${route}`, {
        replace: true,
        state: {
          customerDetails: customerDetails,
        },
      });
    } else {
      // console.log("Selfie Ouch customerDetails ", location);
    }
  }, [customerDetails]);

  const toggleChecked = () => {
    setSelfieKycDataconsent(!selfieKycDataconsent);
    setChecked(!checked);
  };

  const handleUpload = async (event) => {
    setFile(event.target.files[0]);
    // console.log("inside");
    var files = document.querySelector("input[type=file]")["files"][0];

    var reader = new FileReader();
    // console.log("next");
    // console.log(files);

    reader.onload = function () {
      setBase64String(reader.result.replace("data:", "").replace(/^.+,/, ""));
    };
    reader.readAsDataURL(files);
    var zip = new JSZip();
    zip.file("selfie.jpeg", file.split("base64,")[1], {
      base64: true,
    });
    const content = await zip.generateAsync({ type: "blob" });
    // // console.log(await zip.generateAsync({ type: 'blob' }))
    setZipContent(content);
  };

  useEffect(() => {
    if (base64) {
      base64.slice(23);
      setFinalBase64Image(base64);
    } else if (base64String != "") {
      setFinalBase64Image(base64String);
    } else {
      setFinalBase64Image();
    }
  }, [base64, base64String]);

  useEffect(() => {
    if (image) {
      setFinalZip(image);
    } else if (zipContent) {
      setFinalZip(zipContent);
    } else {
      setFinalZip();
    }
  }, [image, zipContent]);

  function validateLocation(latitude, longitude) {
		return (
			latitude != undefined &&
			longitude != undefined &&
			latitude != null &&
			longitude != null &&
			latitude != 0 &&
			longitude != 0 &&
			typeof latitude === 'number' &&
			typeof longitude === 'number' &&
			!isNaN(latitude) &&
			!isNaN(longitude) &&
			latitude != 'None' &&
			longitude != 'None'
		);
	}

  const handleProceedClick = async()=>{
    const payload_2 = {
      selfie_kyc_data_storage: selfieKycDataconsent,
    }
    const src = customerDetails.source;

    await userConsentStatus(payload_2, src);
    await handleOnSubmit();
  }

	const handleOnSubmit = async () => {
		if (validateLocation(userLocation["latitude"],userLocation["longitude"])) {
			if (isInIndia(userLocation["latitude"],userLocation["longitude"])) {
				await callInsertSelfieAPI();
				// // console.log(finalBase64Image)
			} else {
				setShowLocationModal(true)
				setLocationMessage(
					<>
					  <div>Location outside India. Please retry.</div>
					  {/* <div>Attempts left: {locationErrorCount - 1}</div> */}
					</>
				  );
			}
		} else {
			setShowLocationModal(true)
			setLocationMessage(
				<>
					<div>Unable to capture location. Please retry.</div>
				  {/* <div>Attempts left: {locationErrorCount - 1}</div> */}
				</>
			  );
		}
	};

  useEffect(() => {
    if (counter == 3) {
      setRetryModalMessage("Max attempts reached!");
      setShowShimmer(true);
      setMaxRetrySelfie(true);
      setUploadSelfieFailed(true);
    } else {
      if (counter != 0) {
        setRetryModalMessage(
          "Upload a proper Selfie! Number of retries allowed: " + (3 - counter)
        );
        setUploadSelfieFailed(true);
      }
    }
  }, [counter]);

  const maxRetry = () => {
    setFinalBase64Image();
    setChecked(false);
    setBase64(null);
    setImage(null);
    setShowCaptureModal(false);
    setFile("");
    setBase64String("");
    setZipContent();
    setFinalZip();
    setZId();
    setOpenPopup(false);
  };

  const callLivelinessAPI = async () => {
    // console.log("Inside callLivelinessAPI");
    try {
      setShowShimmer(true);
      // console.log("callLivelinessAPI: inside try block");
      // console.log(
      // 	"callLivelinessAPI: stage => ",
      // 	customerDetails.stage
      // );
      const formData = new FormData();
      const requestData = {
        // current_stage: customerDetails.stage,
        userLocation: userLocation,
        // userLocation: {
        // 	"latitude": "",
        // 	"longitude": "",
        // },
      };
      // console.log("callLivelinessAPI: requestData => ", requestData);
      formData.append("data", encryptedData(requestData));
      const response = await sendRequest(
        "/" + customerDetails.source + LIVELINESS,
        formData
      );
      setShowShimmer(false);
      // console.log("callLivelinessAPI: response => ", response);

      if (response.response.Success === true) {
        if (customerDetails.source === "upsell") {
          updateLead(
            customerDetails.source,
            54,
            customerDetails.application_form_number
          );
        } else {
          updateLead(
            customerDetails.source,
            54,
            customerDetails.application_form_number
          );
        }
        // something
        // console.log(
        // 	"************ response.response.STAGE: ",
        // 	response.response.STAGE
        // );
        setCustomerDetails({
          ...customerDetails,
          stage: response.response.STAGE,
        });
        // navigate("/additional", {
        //   replace: true,
        //   state: {
        //     customerDetails: customerDetails,
        //     // application_form_number: customerDetails.application_form_number
        //   },
        // });
      } else if (response.response.Success === false) {
        setCounter(counter + 1);

        // console.log(counter);
      }
    } catch (error) {
      if (customerDetails.source === "upsell") {
        updateLead(
          customerDetails.source,
          67,
          customerDetails.application_form_number
        ); 
      } else {
        updateLead(
          customerDetails.source,
          67,
          customerDetails.application_form_number
        );
      }
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: "error",
      });
      // // console.log("stage: ", customerDetails.stage);
      // console.log("route: ", route);
      navigate(`${route}`, {
        replace: true,
      });
      // console.log("callLivelinessAPI: inside catch block");
    }
  };

  const callInsertSelfieAPI = async () => {
    // console.log("Inside callInsertSelfieAPI");
    try {
      setShowShimmer(true);
      // console.log("callInsertSelfieAPI: inside try block");
      const formData = new FormData();
      const requestData = {
        base64: finalBase64Image,
        userLocation: userLocation
      };
      formData.append("data", encryptedData(requestData));
      const response = await sendRequest(
        "/" + customerDetails.source + INSERT_SELFIE,
        formData
      );

      // console.log("callInsertSelfieAPI: response => ", response);

      if (response.response.Success === true) {
        setCustomerDetails({
          ...customerDetails,
          stage: response.response.STAGE,
        });
      } else if (response.response.Success === false){
        setCounter(counter + 1);
      }
    } catch (error) {
      if (customerDetails.source === "upsell") {
        updateLead(
          customerDetails.source,
          67,
          customerDetails.application_form_number
        );
      } else {
        updateLead(
          customerDetails.source,
          67,
          customerDetails.application_form_number
        );
      }
      // console.log("callInsertSelfieAPI: inside catch block");
      // console.log("ERROR: ", error);
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: "error",
      });
      // // console.log("stage: ", customerDetails.stage);
      // console.log("route: ", route);
      navigate(`${route}`, {
        replace: true,
      });
      setShowShimmer(false);
    }
  };

   // Function to request camera access
   const requestCameraAccess = () => {
    navigator.mediaDevices.getUserMedia({ video: true })
      .then(() => {
        setShowCaptureModal(true);
        setSelfiePermissionMessage("");
      })
      .catch((error) => {
        if (error.name === "NotReadableError") {
          setSelfiePermissionMessage("Camera is in use by another application. Please close other apps and try again.");
        } else {
          setSelfiePermissionMessage("Camera access denied. Please allow it in browser settings.");
        }
      });
  };

  function getCamPermission() {

    if (!navigator.permissions || !navigator.permissions.query) {
      console.warn("Permissions API not supported, directly requesting camera access.");
      requestCameraAccess();
      return;
    }
    navigator.permissions.query({ name: "camera" }).then((permissionStatus) => {
      console.log("permissionStatus.state:", permissionStatus.state)
      if (permissionStatus.state === "granted") {
        setShowCaptureModal(true);
        setSelfiePermissionMessage("");
      } 
       else { // If permission is 'prompt' or "denied", request access
        setSelfiePermissionMessage("Camera access denied. Please allow camera access in settings.!");
        requestCameraAccess();
      }
    
    // Listen for permission changes
    permissionStatus.onchange = () => {
      if (permissionStatus.state === "granted") {
        setShowCaptureModal(true);
        setSelfiePermissionMessage("");
      } 
      // else if (permissionStatus.state === "denied") {
      //   setSelfiePermissionMessage("Camera access denied. Please allow camera access in settings.!");
      // }
      else { // If permission is 'prompt' or "denied", request access
        console.log("on permission change")
        setSelfiePermissionMessage("Camera access denied. Please allow camera access in settings.!");
        requestCameraAccess();
        setShowCaptureModal(false);
      }
    };

  }).catch((error) => {
    setSelfiePermissionMessage("Unable to check camera permission. Please try again.");
  });
  }

  function getUserLocation() {
    // console.log("\tInside getUserLocation");
    // userConsentStatus
    setlocationAccessConsent(true);
    setLocationMessage("Fetching your location ...");
    if (navigator.geolocation) {
      var options = {
        enableHighAccuracy: true,
        timeout: 15000, // Timeout in milliseconds (adjust as needed)
        maximumAge: 0, // Cache maximum age in milliseconds (adjust as needed)
      };
      navigator.geolocation.getCurrentPosition(
        showPosition,
        showError,
        options
      );
    } else {
      setLocationMessage("Geolocation is not supported by this browser.");
      // console.log("\t\t\tGeolocation is not supported by this browser.");
    }
    // console.log("\tOut getUserLocation");
  }

  const invokeLocationAccessConsent = async () =>{
    const payload_1 = {
      seflie_location_access_for_kyc: locationAccessConsent,
    }
    const src = customerDetails.source;

    await userConsentStatus(payload_1 , src);
  }

  function showPosition(position) {
    // console.log("\t\tInside showPosition");
    var locationInfo = {};
    locationInfo["latitude"] = position.coords.latitude;
    locationInfo["longitude"] = position.coords.longitude;
    locationInfo["accuracy"] = position.coords.accuracy;
    locationInfo["altitude"] = position.coords.altitude;
    locationInfo["altitudeAccuracy"] = position.coords.altitudeAccuracy;
    locationInfo["heading"] = position.coords.heading;
    locationInfo["speed"] = position.coords.speed;
    locationInfo["timestamp"] = position.timestamp;
    if (validateLocation(locationInfo["latitude"],locationInfo["longitude"])) {
        if (isInIndia(locationInfo["latitude"],locationInfo["longitude"])) {
          moengage?.track_event("location",{
            journey_name: customerDetails.source,
            latitude: locationInfo["latitude"],
            longitude: locationInfo["longitude"],
          })
          setUserLocation({
            ...userLocation,
            latitude: locationInfo["latitude"],
            longitude: locationInfo["longitude"],
            // accuracy: locationInfo["accuracy"],
            // altitude: locationInfo["altitude"],
            // altitudeAccuracy: locationInfo["altitudeAccuracy"],
            // heading: locationInfo["heading"],
            // speed: locationInfo["speed"],
            // timestamp: locationInfo["timestamp"],
          });
          // console.log("\t\t\tlocationInfo: ", locationInfo);
          setLocationMessage("Received Your Location.");
          setTimeout(() => {
            setShowLocationModal(false);
            setLocationMessage("");
            setShowSelfiePermissionModal(true);
            // setShowCaptureModal(true);
            invokeLocationAccessConsent()
          }, 1000);
        } else {
          if (locationErrorCount > 0) {
            setLocationErrorCount(prevCount => prevCount - 1);
          }
          if (locationErrorCount <= 0) {
              sessionStorage.setItem("lastApiCall", "locationNotInIndiaError");
              navigate(`/${customerDetails.source}/error`);
          } else {
              setLocationMessage(
                <>
                    <div>Location outside India. Please retry.</div>
                    {/* <div>Attempts left: {locationErrorCount - 1}</div> */}
                </>
              );
          }
        }
    } else {
        if (locationErrorCount > 0) {
          setLocationErrorCount(prevCount => prevCount - 1);
        }
        if (locationErrorCount <= 0) {
            sessionStorage.setItem("lastApiCall", "locationNullError");
            navigate(`/${customerDetails.source}/error`);
        } else {
            setLocationMessage(
              <>
                  <div>Unable to capture location. Please retry.</div>
                {/* <div>Attempts left: {locationErrorCount - 1}</div> */}
              </>
            );
        }
      }
    // console.log("\t\t\tlocationInfo: ", locationInfo);
    // console.log("\t\tOut showPosition");
  }

  function showError(error) {
    // console.log("\t\tInside showError");
    switch (error.code) {
      case error.PERMISSION_DENIED:
        setLocationMessage(
          "User denied the request for Geolocation. Please allow location access from your browser settings and try again."
        );
        // console.log("\t\t\tUser denied the request for Geolocation. Please allow location access from your browser settings and try again.");
        break;
      case error.POSITION_UNAVAILABLE:
        setLocationMessage(
          "Location information is unavailable. Please enable GPS and try again."
        );
        // console.log("\t\t\tLocation information is unavailable. Please enable GPS and try again.");
        break;
      case error.TIMEOUT:
        setLocationMessage(
          "The request to get user location timed out. Please try again."
        );
        // console.log("\t\t\tThe request to get user location timed out. Please try again.");
        break;
      case error.UNKNOWN_ERROR:
        setLocationMessage("An unknown error occurred.");
        // console.log("\t\t\tAn unknown error occurred.");
        break;
      default:
        setLocationMessage("An unknown error occurred.");
        // console.log("\t\t\tAn unknown error occurred.");
        break;
    }
    // console.log("\t\tOut showError: ", locationMessage);
  }
  
  return (
    <>
      <ProgressBar showProgress={true} currentStep={4} />
      <AfterLoginLayoutWrapper width={"75%"}>
        <Loading open={modal === "LOADING"} />
        <UploadSelfieFailedModal
          isOpen={uploadSelfieFailed}
          onClose={() => {
            if (maxRetrySelfie) {
              var route = getRouteFromLoanStageService({
                source: customerDetails.source,
                stage: "",
              });
              // console.log("route: ", route);
              navigate(`${route}`, {
                replace: true,
              });
            }
            setShowShimmer(false);
            setUploadSelfieFailed(false);
          }}
          modalMessage={retryModalMessage}
        />
        <Modal open={modal === "TECHNICAL_ERROR"} onClose={() => setModal("")}>
          <ErrorModal />
        </Modal>
        <LocationCaptureModal
          isOpen={showLocationModal}
          onClose={() => {
            setShowLocationModal(false);
            setUserLocation({
              ...userLocation,
              latitude: 0,
              longitude: 0,
            });
            setLocationMessage("");
          }}
          onModalSubmit={() => {
            // console.log("Getting Location...");
            setLocationMessage("");
            getUserLocation();
            // console.log("Got Location...");
          }}
          locationMessage={locationMessage}
        />
        <SelfiePermissionCaptureModal
          isOpen={showSelfiePermissionModal}
          onClose={() => {
            setShowSelfiePermissionModal(false);
            setSelfiePermissionMessage("")
          }}
          onModalSubmit={() => {
            setSelfiePermissionMessage("");
            getCamPermission();
          }}
          locationMessage={selfiePermissionMessage}
        />
        <Modal
          showCloseButton={false}
          open={showCaptureModal}
          onClose={() => setShowCaptureModal(false)}
        >
          <SelfieCaptureModal
            setSelfie={(blob, b64) => {
              setImage(blob);
              setBase64(b64);
            }}
          />
        </Modal>
        <SelfieForm className="first-child">
          <div className="basic-form-title">
            <ShimmerPlaceholder visible={showShimmer} width="15em" />
            <Title
              id="pageTitle"
              className="pageTitle"
              text={`Let's take your selfie!`}
              icon={
                <>
                  <img
                    src={selfieTitleIcon}
                    alt="titleIcon.svg"
                    height="22"
                    width="22"
                  />
                </>
              }
              visible={!showShimmer}
              clickable={false}
            />
            <ShimmerPlaceholder
              visible={showShimmer}
              width="18em"
              height="3em"
              marginTop="-1em"
            />
            <SubTitle
              id="pageSubTitle"
              className="pageSubTitle"
              text={`Click a clear picture of yourself in good light`}
              visible={!showShimmer}
              clickable={false}
              style={{ padding: "10px 0" }}
            />
            <SubTitle
							id="pageSubTitle"
							className="pageSubTitle"
							text={`This is required for KYC purpose`}
							visible={!showShimmer}
							clickable={false}
							style={{ padding: "10px 0" }}
						/>
          </div>
          <div id="selfie-form">
            {showShimmer ? (
              <>
                <ShimmerPlaceholder
                  visible={showShimmer}
                  height="20em"
                  marginTop="-1em"
                />
                <ShimmerPlaceholder visible={showShimmer} height="5em" />
              </>
            ) : (
              <>
                {file != "" ? (
                  <img
                    id={"selfie-img"}
                    className="selfie-placeholder"
                    src={URL.createObjectURL(file)}
                    alt={"Selfie"}
                  />
                ) : (
                  <img
                    id={image ? "selfie-img" : "selfie-placeholder"}
                    className="selfie-placeholder"
                    src={image ? base64 : SelfieCapturePng}
                    alt={image ? "" : "Upload Selfie"}
                  />
                )}
                {image || file ? (
                  <CheckField
                    id="selfie-checkfield"
                    className="mx-auto"
                    checked={checked}
                    label="I hereby authorize Aditya Birla Capital Limited to collect, store, verify my KYC details (from CERSAI/Digilocker) and my application data for KYC purposes."
                    style={{
                      fontSize: "1.4rem",
                    }}
                    onClick={toggleChecked}
                  />
                ) : null}
              </>
            )}

            {showShimmer ? (
              <>
                <div id="proceed-recapture">
                  <ShimmerPlaceholder visible={showShimmer} width="10em" />
                  <ShimmerPlaceholder visible={showShimmer} width="10em" />
                </div>
              </>
            ) : (
              <>
                <div>
                  {image || file ? (
                    <div id="proceed-recapture">
                      <Button
                        id="proceed"
                        className="Btn proceed"
                        disabled={image || file ? !checked : false}
                        mobile={isMobile}
                        text={"Proceed"}
                        onClick={
                          image || file
                            ? handleProceedClick
                            : () => setShowCaptureModal(true)
                        }
                        // style={{
                        //   marginTop: "10px",
                        //   marginBottom: isMobile ? "0px" : "20px",
                        //   backgroundColor: "#CB3443",
                        //   border: "0px solid #CB3443",
                        //   boxShadow: "none",
                        //   width: "127px",
                        //   height: "36px",
                        //   borderRadius: "15px",
                        //   padding: "0px",
                        //   fontSize: "20px",
                        // }}
                      />
                      <Button
                        id="recapture"
                        className="Btn recapture"
                        disabled={false}
                        mobile={isMobile}
                        onClick={() => {
                          setShowCaptureModal(true);
                          setImage(null);
                          setFile("");
                          maxRetry();
                        }}
                        text={"Re-capture"}
                        // style={{
                        //     marginTop: "10px",
                        //     marginBottom: isMobile ? "0px" : "20px",
                        //     backgroundColor: "#CB3443",
                        //     border: "0px solid #CB3443",
                        //     boxShadow: "none",
                        //     width: "127px",
                        //     height: "36px",
                        //     borderRadius: "15px",
                        //     padding: "0px",
                        //     fontSize: "20px",
                        // }}
                      />
                    </div>
                  ) : (
                    <div id="capture-upload">
                      {/* <input
												type="file"
												name="Image"
												accept="image/*"
												id="upload-file"
												onChange={handleUpload}
											/> */}
                      {/* <Button
                    id="selfie-submit-btn"
                    className="mx-auto"
                    disabled={image ? !checked : false}
                    mobile={isMobile}
                    onClick={image ? handleOnSubmit :
                      () => {
                        setShowCaptureModal(true);
                        setFile("");
                      }}
                    style={{
                      fontSize: isMobile ? '1.6rem' : ''
                    }}
                  >Capture</Button> */}
                      <Button
                        id="capture"
                        className="Btn capture"
                        disabled={image ? !checked : false}
                        mobile={isMobile}
                        onClick={
                          image
                            ? handleOnSubmit
                            : () => {
                                setLocationMessage("");
                                setUserLocation({
                                  ...userLocation,
                                  latitude: 0,
                                  longitude: 0,
                                });
                                if (customerDetails.source !== "upsell") {
                                  setShowLocationModal(true);
                                } else {
                                  setShowCaptureModal(true);
                                }
                                setFile("");
                              }
                        }
                        text={"Capture"}
                        // style={{
                        //     marginTop: "10px",
                        //     marginBottom: isMobile ? "0px" : "20px",
                        //     backgroundColor: "#CB3443",
                        //     border: "0px solid #CB3443",
                        //     boxShadow: "none",
                        //     width: "127px",
                        //     height: "36px",
                        //     borderRadius: "15px",
                        //     padding: "0px",
                        //     fontSize: "20px",
                        // }}
                      />
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </SelfieForm>
      </AfterLoginLayoutWrapper>
    </>
  );
}

export default EPL_Selfie_think;
